(function($) {
  var dictator = {

    selectors: ['#dict-2'], // List of articles.
    tickers: {}, // Holds setInterval handles.
    states_audio: {}, // Holds current audio playing states for articles.
    states_coloration: {}, // Holds current text coloration states.

    autoplay_forbidden: true,
    audio_ctx: {},
    audio_elements: {},
    gain_node: {},

    debugging: false,

    debug: function(message, type = 'log') {
      if (this.debugging) {
        switch (type) {
          case 'log':
            console.log(message);
            break;
          default:
            console.log(message);
            console.
            break;
        }
      }
    },

    spanifyArticle: function(selector) {

      const mode = 'words';
      const wrapper = 'span';
      const open = '<' + wrapper + '>';
      const close = '</' + wrapper + '>';

      let char, nchar;
      let output;
      let iserror = false;
      let chunks = 0;

      var isWhiteCharacter = function(char) {
        return /\s/.test(char);
      };
      var isPunctuation = function(char) {
        return ['.', '?', '!', ',', ':', ';'].includes(char);
      };

      // Wrap each letter but consider punctuation marks.
      var wrapLetters = function(str) {
        output = '';
        str = str.trim();
        for (var i = 0; i < str.length; i++) {
          char = str.charAt(i);
          nchar = str.charAt((i + 1));

          if (! isWhiteCharacter(char)) {
            if (isPunctuation(char)) {
              output += char;
            } else {
              output += open + char;
            }
            if (! isPunctuation(nchar)) {
              output += close;
              chunks++;
            }
          } else {
            output += char;
          }
        }

        if (str !== '' && output === '') {
          iserror = true;
        }
        return output;
      };

      // Wrap words and "inteligently" split long words.
      var wrapWords = function(str) {
        output = '';
        let word_marks = [];
        let break_marks = [];
        let length;
        str = str.trim();

        // Add word boundry markings.
        for (var i = 0; i < str.length; i++) {
          char = str.charAt(i);
          nchar = str.charAt((i + 1));

          if (i === 0) {
            // String opening.
            output += open + char;
            word_marks.push(output.length - 1);
          } else if (isWhiteCharacter(char) && (! isWhiteCharacter(nchar))) {
            // Begining of the word.
            output += char + open;
            word_marks.push(output.length);
          } else if (isWhiteCharacter(nchar)) {
            // End of the word.
            word_marks.push(output.length);
            output += char + close;
            chunks++;
          } else {
            // Middle of the word
            output += char;
          }

          if (i === str.length - 1) {
            // Close the entire string
            word_marks.push(output.length-1);
            output += close;
            chunks++;
          }

        }

        // Calculate word slicing positions.
        for (var j = 0; j < word_marks.length; j = j + 2) {
          length = word_marks[j + 1] - word_marks[j] + 1;
          switch (length) {
            case 4:
            case 5:
              break_marks.push(word_marks[j] + 2);
              break;
            case 6:
            case 7:
              break_marks.push(word_marks[j] + 3);
              break;
            case 8:
              break_marks.push(word_marks[j] + 2);
              break_marks.push(word_marks[j] + 5);
              break;
            case 9:
            case 10:
              break_marks.push(word_marks[j] + 3);
              break_marks.push(word_marks[j] + 6);
              break;
            case 11:
              break_marks.push(word_marks[j] + 2);
              break_marks.push(word_marks[j] + 5);
              break_marks.push(word_marks[j] + 8);
              break;
          }
          if (length > 11) {
            break_marks.push(word_marks[j] + 3);
            break_marks.push(word_marks[j] + 7);
            break_marks.push(word_marks[j] + 10);
          }
        }

        // Slice words.
        for (var k = (break_marks.length - 1); k >= 0; k--) {
          output = output.slice(0, break_marks[k]) + close + open + output.slice(break_marks[k]);
          chunks++;
        }

        if (str !== '' && output === '') {
          iserror = true;
        }

        return output;
      }

      var verses = $(selector).children('p');
      var wrapped;
      $(verses).each(function() {
        if (mode === 'words') {
          wrapped = wrapWords($(this).text());
        } else if (mode === 'letters') {
          wrapped = wrapLetters($(this).text());
        }
        $(this).html(wrapped);
      });

      return new Promise(function(resolve, reject){
        if (iserror) {
          reject({success: false, message: 'Something went wrong!'});
        } else {
          resolve({
            success: true,
            message: 'Text fragmentation has been successfull.',
            selector: selector,
            wrapper: wrapper,
            chunks: chunks
          });
        }
      });
    },

    initAudioElements: function() {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      this.audio_ctx = new AudioContext();

      this.gain_node = this.audio_ctx.createGain();
      this.gain_node.gain.value = 0;

      let inst = this;
      let result = true;
      return new Promise(function(resolve, reject) {
        inst.selectors.forEach(function(selector, index) {
          inst.audio_elements[selector] = document.querySelector('audio' + selector + '-audio' );
          let track = inst.audio_ctx.createMediaElementSource(inst.audio_elements[selector]);
          track.connect(inst.gain_node).connect(inst.audio_ctx.destination);
          result = result && inst.audio_elements[selector] !== '';
        });

        if (result) {
          resolve("Audio elements attached.");
        } else {
          reject("Failed to attach audio elements.");
        }
      });
    },

    startAudio: async function(selector) {
      if (this.states_audio[selector] === false) {
        this.debug("Starting Audio: " + selector);
        await this.stopAll('audio');
        this.states_audio[selector] = true;
        this.audio_elements[selector].play().catch(function(error) {
          console.error('Playing not yet permitted due to autoplay policy.');
        });
      }
    },

    startColoration: async function(selector, chunks, duration) {
      if (this.states_coloration[selector].running === false) {
        this.debug("Starting Coloration " + selector + " (" + chunks + " chunks, duration: " + duration + ")");
        await this.stopAll('coloration');
        this.states_coloration[selector].running = true;
        duration *= 1000;
        let interval = duration / chunks;
        this.debug("Interval: " + interval);
        let i = 0;
        let inst = this;
        let pieces = $(selector + ' span');
        inst.tickers[selector] = setInterval(function() {
          $($(pieces)[i++]).addClass('pink-text');
          if (i > chunks) {
            inst.stopColoration(selector, false);
          }
        }, interval);
      }
    },

    stopAudio: function(selector) {
      this.debug("Stopping Audio: " + selector);
      this.audio_elements[selector].pause();
      this.audio_elements[selector].currentTime = 0;
      this.states_audio[selector] = false;
    },

    stopColoration: function(selector, reset = true) {
      this.debug("Stopping Coloration: " + selector + (reset ? " (with reset)" : ""));
      clearInterval(this.tickers[selector]);
      if (reset) {
        $(selector + ' span').removeClass('pink-text');
      }
      this.states_coloration[selector].running = false;
    },

    stopAll: function(type) {
      let inst = this;
      return new Promise(function(resolve, reject) {
        inst.selectors.forEach(function(selector, index) {
          if (type === 'audio' && inst.states_audio[selector]) {
            inst.stopAudio(selector);
          }
          if (type === 'coloration' && inst.states_coloration[selector].running) {
            inst.stopColoration(selector);
          }
        });
        resolve(true);
      });
    },

    muteAudio: function() {
      this.debug("Muting all audio elements");
      this.gain_node.gain.value = 0;
    },

    unmuteAudio: function() {
      this.debug("Unmuting all audio elements");
      this.gain_node.gain.value = 0.7;
      let inst = this;
      this.selectors.forEach(function(selector, index) {
        inst.audio_elements[selector].muted = false;
      });
    },

    restartSection: function(selector) {
      this.stopColoration(selector);
      this.stopAudio(selector);
      this.startColoration(
        selector,
        this.states_coloration[selector].chunks,
        this.audio_elements[selector].duration
      );
      this.startAudio(selector);
    },

    bindAudioButtons: function() {
      let inst = this;
      $('.audio-dictation-btn').on('click', function(e) {
        if ($(this).hasClass('active')) {
          inst.muteAudio();
          $('.audio-dictation-btn').removeClass('active').children('span').text('This page has audio, click to enable.');
        } else {
          inst.unmuteAudio();
          $('.audio-dictation-btn').addClass('active').children('span').text('Audio enabled, click to disable.');
          inst.debug(inst.audio_ctx.state);
          if (inst.autoplay_forbidden) {
            let selector = '#' + $(this).attr('id').replace('-button', '');
            if (inst.audio_ctx.state === 'suspended') {
              inst.audio_ctx.resume().then(function() {
                inst.restartSection(selector);
              });
            } else {
              inst.autoplay_forbidden = false;
            }
          }
        }
      });
    },

    initArticleDictator: function(frag_results) {
      let selector = frag_results.selector;
      let chunks = frag_results.chunks;
      let inst = this;

      this.states_audio[selector] = false;
      this.states_coloration[selector] = {
        running: false,
        chunks: chunks
      };

      new Waypoint.Inview({
        element: $(selector),
        enter: function(direction) {
          window.setTimeout(function() {
            inst.debug("Entering " + selector);
            inst.startAudio(selector);
            inst.startColoration(selector, chunks, inst.audio_elements[selector].duration);
          }, 100);
        },
        exited: function(direction) {
          inst.debug("Exited " + selector);
          inst.stopAudio(selector);
          inst.stopColoration(selector);
        }
      });
    },

    init: function() {
      let inst = this;
      this.initAudioElements().then(function(results) {
        inst.bindAudioButtons();

        inst.selectors.forEach(function(selector) {
          inst.spanifyArticle(selector).then(function(results) {
            inst.initArticleDictator(results);
          }, function(results) {
            inst.debug(results);
          });
        });
      });
    }
  }

  dictator.init();

  // smooth-scroll
  function scrollToTarget(target, shift = 0, timing = 500) {
   $('html, body').animate({
    scrollTop: $(target).offset().top + shift
   }, timing);
  }

  $('.smooth-scroll').on('click', function(e) {
    e.preventDefault();
    var target = $(this).attr('href');
    scrollToTarget(target);
  })

  // source code passing
  $('.donate-button').each(function() {
    var self = $(this);
    if (location.search != "") {
      href = self.attr('href') + '&' +location.search.substr(1);
      self.attr('href', href);
    }
  });

})(jQuery);
